import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  Rol
} from '@app/shared';

@Injectable()
export class GroupsPermissionsDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Consulta los roles del sistema(grupos).
   *
   * @returns {Observable<Rol[]>}
   * @memberof GroupsPermissionsDataService
   */
  getRoles(): Observable<Rol[]> {
    return this.http.get<Rol[]>(this.api.get('roles'));
  }

  /**
   * Consulta un rol(grupo).
   *
   * @param {number} idRol
   * @returns {Observable<Rol>}
   * @memberof GroupsPermissionsDataService
   */
  getRole(idRol: number): Observable<Rol> {
    return this.http.get<Rol>(this.api.get('roles', [idRol]));
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/shared/groups-permissions.data.service.ts